export const errorSerializer = (data) => {
    let error = objectToString(data?.data)
    return error;
}

const objectToString = (obj) => {
    let returnString = 'Something went wrong'
    console.log(obj, "==========")
    if(obj?.detail || obj?.data){
        if(Array.isArray(obj?.detail)){
            obj.detail.forEach((ele) => {
                if(!Array.isArray(ele)){
                    if(ele?.loc && ele.loc[1] && ele?.msg){
                        returnString = `${ele.loc[1].split('_').join(' ')} - ${ele?.msg}`
                    }
                }
            })
        }else {
            returnString = JSON.stringify(obj?.detail)
        }
    }
    return returnString
}

